/*eslint-env browser*/

export const removeScriptBySrc = (scriptSrc) => {
    if (document) {
        const element = document.querySelectorAll(`script[src="${scriptSrc}"]`);
        element[0] && element[0].remove();
    }
};
